import * as Product from '#/unified-rfqs/ui/rfqs/product-functions';

import { State } from '#/unified-rfqs/ui/rfq-builder/store';
import { PRODUCTS } from '#/products/config';
import { STRATEGIES, StrategyShortCode } from '#/shared/strategies';
import { venueSupportsCustomStrategy } from '#/unified-rfqs/entities/products/venue';

const excludedStrategies = new Set<StrategyShortCode>(['PD', 'CD', 'FF']);

const predefinedStrategies = Object.values(STRATEGIES).filter(
  (strategy) => !excludedStrategies.has(strategy.shortCode),
);

const CUSTOM_STRATEGY_OPTION = {
  value: null,
  label: 'Custom',
  isDisabled: false,
};

export default function strategyShortcutView(
  selectedProductCode: State['productCode'],
  selectedStrategyCode: State['strategyCode'],
  selectedVenue: State['venue'],
) {
  const product =
    selectedProductCode != null ? PRODUCTS[selectedProductCode] : null;

  const predefinedOptions = predefinedStrategies.map((strategy) => ({
    value: strategy.code,
    label: strategy.code,
    isDisabled: !Product.supportsStrategyShortcuts(product, strategy),
  }));

  const options = venueSupportsCustomStrategy(selectedVenue)
    ? [...predefinedOptions, CUSTOM_STRATEGY_OPTION]
    : predefinedOptions;

  const selectedOption =
    options.find((option) => option.value === selectedStrategyCode) ?? null;

  return { options, selectedOption };
}
